export default "__VITE_ASSET__CJ0yUTrG__"